import { createMuiTheme } from 'pencil/styles';
import * as config from './const';

export const theme = createMuiTheme({
  '@global': {
    a: {
      textDecoration: 'underline',
    },
  },
  typography: {
    useNextVariants: true,
    color: config.colors.slate,
    fontFamily: [config.fontFamily],
    h2: {
      fontSize: 32,
      fontWeight: 900,
      marginBottom: 15,
    },
    subtitle2: {
      fontSize: 16,
      fontWeight: 900,
      color: '#000000',
      marginBottom: 15,
    },
    body2: {
      fontSize: 14,
      color: '#000000',
    },
    overline: {
      lineHeight: 1.43,
    },
  },
  overrides: {
    MuiTypography: {
      root: { color: config.colors.slate },
    },
    MuiCard: {
      root: { boxShadow: 'none' },
    },
    MuiSnackbarContent: {
      root: { color: config.colors.slate },
    },
    MuiDivider: {
      root: {
        // marginTop: 20,
        // marginBottom: 20,
        backgroundColor: config.colors.lightGrey,
      },
    },
    CirceSelectField: {
      selectRoot: {
        marginTop: 0,
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiFormHelperText: {
      root: {
        marginTop: -8,
      },
    },
    MuiLink: {
      root: {
        color: config.colors.blue,
      },
    },
  },
  colors: { ...config.colors },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: config.colors.dirtyYellow,
      // dark: will be calculated from palette.primary.main,
      contrastText: config.colors.black,
    },
    secondary: {
      main: config.colors.slate,
      // dark: will be calculated from palette.primary.main,
      contrastText: config.colors.grey,
    },
    error: {
      main: config.colors.red,
      contrastText: config.colors.white,
    },
    background: {
      default: config.colors.white,
    },
  },
  shipments: {
    colors: {
      draft: {
        color: config.colors.grey,
      },
      delivered: {
        color: config.colors.dirtyYellow,
      },
      cancelled: {
        color: config.colors.red,
      },
      enroute: {
        color: config.colors.orange,
      },
      scheduled: {
        color: config.colors.orange,
      },
      rejected: {
        color: config.colors.red,
      },
      delayed: {
        color: config.colors.orange,
      },
      confirmed: {
        color: config.colors.green,
      },
      dispatched: {
        color: config.colors.orange,
      },
      exception: {
        color: config.colors.red,
      },
      loading: {},
    },
  },
  tables: {
    starsRatingWrapper: {
      color: config.colors.dirtyYellow,
      marginLeft: 20,
      '& svg': {
        fontSize: 18,
      },
    },
    cellWithIconWrapper: {},
  },
  layout: {
    width: 'xl',
  },
  branding: {
    logo: {
      standard: require('assets/themes/masheed/img/masheed.png'),
      icon: require('assets/themes/masheed/img/logo.svg'),
    },
    background: {
      primary: '#fff',
      secondary: '#F6F7FC',
    },
    primary: {
      hover: '#4e5f69',
    },
    company: {
      name: SYSTEM_DOMAIN,
    },
  },
  status: {
    colors: {
      active: '#0084F3',
      inactive: '#ccc',
    },
  },
  tabs: {
    background: {
      active: config.colors.lightYellow,
    },
    colors: {
      active: config.colors.activeGrey,
    },
  },
  newfilterAutocomplete: {
    background: '#CBE3FF',
  },
});
